module.exports = __webpack_public_path__ + "static/lightville-full-c6a205732155c352aac8e74e4486f218.png";